
import  { useEffect, useState } from "react";
import "./PhotographerRatingModal.css";
import Loader from "../../../../Loader/Loader";
import CommonMessageModal from "../../../../CommonMessageModal/CommonMessageModal";
import { getAdminRatingAPI, givePhotographerRatingAPI } from "../../../../utils/APIs/photographersApis";

const PhotographerRatingModal = ({ isOpen, onClose, photographer }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");
  const [existingRating, setExistingRating] = useState(null);

  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setRating(null);
    setComment("");
    setExistingRating(null);
    setShowMessage(false);
    setMessage("");
  }, [isOpen, photographer?._id, photographer?.photographerId]);

  const handleSubmit = async () => {
    const photographerId = photographer?._id || photographer?.photographerId;

    if (!photographerId) {
      setMessage("Photographer ID missing.");
      setShowMessage(true);
      return;
    }

    if (!rating) {
      setMessage("Please select a rating.");
      setShowMessage(true);
      return;
    }

    if (existingRating) {
      setMessage("You have already submitted feedback for this photographer.");
      setShowMessage(true);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        photographerId,    
        ratingCount: Number(rating),
        rateComments: comment || "",
        createdBy : "admin",
      };

      const res = await givePhotographerRatingAPI(payload);

      if (res?.data?.success) {
        setMessage(res?.data?.message || "Thanks for your feedback!");
        setExistingRating({
          ratingCount: Number(rating),
          rateComments: comment || "",
        });
      } else {
        setMessage(res?.data?.message || "Failed to submit rating.");
      }
    }
    catch (err) {
  console.error("Failed to fetch rating", err);

  if (err?.response?.status === 500) {
    setMessage("Server error while submit rating. Please try again.");
  } else if (!navigator.onLine) {
    setMessage("No internet connection.");
  } else {
    setMessage("Something went wrong while submit rating.");
  }

  setShowMessage(true);
}
    finally {
      setLoading(false);
      setShowMessage(true);
    }
  };

  useEffect(() => {
  const fetchRating = async () => {
    const photographerId = photographer?._id || photographer?.photographerId;

    if (!photographerId || !isOpen) return;

    try {
      setLoading(true);

      const res = await getAdminRatingAPI();

      if (res?.data?.success) {
        const ratings = res.data.adminRating;

        const found = ratings.find(
          (r) => r.photographerId === photographerId
        );

        if (found) {
          setExistingRating(found);
          setRating(found.ratingCount);
          setComment(found.rateComments || "");
        }
      }
    } catch (err) {
      console.error("Failed to fetch rating", err);
    } finally {
      setLoading(false);
    }
  };

  fetchRating();
}, [isOpen, photographer]);

  if (!isOpen) return null;
  if (loading) return <Loader />;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.45)",
        zIndex: 9999,
      }}
    >
      <div className="rating-page-wrapper">
        <div className="rating-card">
          <button className="rating-close" onClick={onClose} type="button">
            ×
          </button>

          <h2 className="rating-title">Rate Us!</h2>
          <p className="rating-subtitle">Tell us your experience</p>

          {existingRating && (
            <p className="already-rated-text">
              You have already submitted feedback for this photographer.
            </p>
          )}

          <div className="rating-scale">
            {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
              <button
                key={num}
                className={`rating-circle ${rating === num ? "active" : ""}`}
                onClick={() => setRating(num)}
                disabled={loading || existingRating}
              >
                {num}
              </button>
            ))}
          </div>

          <div className="rating-labels">
            <span>Worst</span>
            <span>Best</span>
          </div>

          <div className="comment-section">
            <label>Can you tell us more ?</label>
            <textarea
              placeholder="Add Comment.."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              disabled={loading || existingRating}
            />
          </div>

          <button
            className="submit-btn"
            onClick={handleSubmit}
            disabled={loading || existingRating}
          >
            {existingRating ? "Already Rated" : "Submit"}
          </button>
        </div>

        <CommonMessageModal
          show={showMessage}
          onClose={() => setShowMessage(false)}
          message={message}
          buttonText="Okay"
        />
      </div>
    </div>
  );
};

export default PhotographerRatingModal;
